import { SITE } from "@/data/site";
import { TOMORROW_COPY, tomorrowNames } from "@/data/tomorrow-co";
import tokens from "./tomorrow-tokens.module.css";
import styles from "./TomorrowFooter.module.css";

/** Tomorrow Co's own footer, in place of the site footer on its page only (owner, 2026-11-04).
 *  It carries the links the site footer has, so nothing required disappears. */
export default function TomorrowFooter({ name }: { name: string }) {
  return (
    <footer className={`${tokens.tc} ${styles.footer}`}>
      <div className={styles.inner}>
        <span className={styles.wordmark}>{tomorrowNames(name).wordmark}</span>
        <p className={styles.mission}>{TOMORROW_COPY.mission}</p>
        <p className={styles.donation}>{TOMORROW_COPY.donation}</p>
        <p className={styles.disclaimer}>{TOMORROW_COPY.disclaimer}</p>
        <nav aria-label={`${name} links`} className={styles.links}>
          <a href="/shop">Shop OddStack</a>
          <a href="/contact">Contact</a>
          <a href="/privacy/">Privacy</a>
          <a href="/terms-of-service/">Terms</a>
        </nav>
        <span className={styles.copyright}>
          &copy; {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
